export enum DirectionOptions {
  asc = 'asc',
  desc = 'desc'
}